import _ from "underscore";

export default {
  user: {
    authenticated: false,
    profile: null,
    permissions: [],
  },
  config: {},
  install(Vue, options) {
    Vue.prototype.$auth = this;
  },
  can(perms) {
    if (!this.user || !this.user.authenticated) return false;
    const profileVal = typeof this.user.profile === 'object'
      ? (this.user.profile ? this.user.profile.profile : null)
      : this.user.profile;
    const emailVal = this.user.email || (typeof this.user.profile === 'object' && this.user.profile ? this.user.profile.email : '');
    const isSuperAdmin = ['SADM', 'SuperAdmin', 'SuperAdministrador', 'SUPER_ADM'].includes(profileVal) || emailVal === 'superadminsgp@labortime.com' || (typeof emailVal === 'string' && emailVal.startsWith('soporte@'));
    if (isSuperAdmin) {
      return true;
    }
    if (!perms) return true;
    if (typeof perms === 'string') {
      perms = [perms];
    }
    if (!Array.isArray(this.user.permissions)) {
      return false;
    }
    return _.intersection(this.user.permissions, perms).length > 0;
  },
  checkUser() {
    return new Promise((resolve, reject) => {
      window.axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("id_token");
      axios
        .get("/api/user/check")
        .then((response) => {
          this.user.authenticated = true;
          this.user.profile = response.data.data;
          // sessionStorage.setItem('permissions', response.data.permissions);
          // console.log(response.data.permissions);
          this.user.permissions = response.data.permissions;
          this.config = response.data.data.config;
          setTimeout(() => {
            if (window.checkAndDisplayAlerts) {
              window.checkAndDisplayAlerts();
            }
          }, 500);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  signin(context, email, password) {
    axios
      .post("/api/signin", {
        email: email,
        password: password,
      })
      .then((response) => {
        // console.log(response);

        context.$parent.$data.message = response.data.message;

        context.error = false;
        localStorage.setItem("id_token", response.data.meta.token);
        window.axios.defaults.headers.common["Authorization"] =
          "Bearer " + localStorage.getItem("id_token");

        this.user.authenticated = true;
        this.user.profile = response.data.data;
        // console.log(this.user.profile);
        // sessionStorage.setItem('email', email);
        // sessionStorage.setItem('password', password);
        // sessionStorage.setItem('permissions', response.data.permissions);
        this.user.permissions = response.data.permissions;
        this.config = response.data.data.config;

        const profileVal = typeof this.user.profile === 'object'
          ? (this.user.profile ? this.user.profile.profile : null)
          : this.user.profile;
        const domainVal = typeof this.user.profile === 'object' && this.user.profile
          ? this.user.profile.domain
          : null;
        const isGlobal = domainVal === 'global' || ['GlobalViewer', 'AuditorGlobal', 'GLOBAL_VIEWER'].includes(profileVal);

        let path_after_login = localStorage.getItem("path_after_login");
        if (isGlobal || !path_after_login || path_after_login === '/' || path_after_login === '/dashboard') {
          path_after_login = isGlobal ? "/reports/globalheadcount" : "/dashboard";
        }

        context.$router.push(path_after_login);
        setTimeout(() => {
          if (window.checkAndDisplayAlerts) {
            window.checkAndDisplayAlerts();
          }
        }, 600);
      })
      .catch((response) => {
        context.error = true;
      });
  },
  signout(context) {
    localStorage.removeItem("id_token");
    this.user.authenticated = false;
    this.user.profile = null;

    if (context.$parent != undefined) {
      context.$parent.$data.message = null;
      context.$parent.closeTimeAlert();
    } else if (context.$data.message != undefined) {
      context.$data.message = null;
      context.$parent.closeTimeAlert();
    }

    // sessionStorage.removeItem('email');
    // sessionStorage.removeItem('password');
    // sessionStorage.removeItem('permissions');
    this.user.permissions = [];
    context.$store.dispatch("resetState");
    context.$router.push("/login");
  },
};
